import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { useSearchResultsContext } from "@/components/Search/SearchResults/context/searchResults.context";

import { SEARCH_PRODUCT_ID } from "../../../numberOfHits/numberOfHits.config";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const { showFacets } = useSearchResultsContext();

    return (
        <article
            id={SEARCH_PRODUCT_ID}
            className={cn("tw:col-[1/3]", "tw:lg:col-[2/3]", {
                "tw:lg:col-1!": !showFacets
            })}
        >
            {children}
        </article>
    );
};

export { Base };
